import {Avatar, Badge, Button, Input, Tag} from 'antd'
import {referral_getReferralCode_Api} from 'apis'
import {organizationModel} from 'apis/model'
import {UpdateReferalCode} from 'components/UpdateReferalCode'
import copyToClipboard from 'copy-to-clipboard'
import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import useAsync from 'modules/asyncCache/useAsync'
import useTranslate from 'modules/local/useTranslate'
import React, {useLayoutEffect} from 'react'
import {Link} from 'react-router-dom'
import useToggle from 'react-use/lib/useToggle'
import {AppLogoSvg} from "../../../appConfigs/svgs/AppLogoSvg";
import {renderIf} from "../../Shared";
import {parseDayjs} from "../../../helpers/datetimeHelpers";
import LoadingBlock from "../../Loading/LoadingBlock";

const Invite = ({item, showTitle = true}) => {
    const t = useTranslate()

    const [isToggle, toggle] = useToggle(
        false
    )
    const [
        isToggleCopy2,
        toggleCopy2
    ] = useToggle(false)
    const {response} = useAsync({
        apiInfo: referral_getReferralCode_Api,
        values: {
            target_id: item.id,
            target_type: item._type
        }
    })
    useLayoutEffect(() => {
        let timeout
        if (isToggle) {
            timeout = setTimeout(
                () => toggle(false),
                800
            )
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [isToggle, toggle])

    useLayoutEffect(() => {
        let timeout
        if (isToggleCopy2) {
            timeout = setTimeout(
                () => toggleCopy2(false),
                800
            )
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [isToggleCopy2, toggleCopy2])

    const data = _.get(response, 'data')
    if (!data) return <LoadingBlock/>
    const inviteLink =
        ROOT_URL +
        '/invite/organization/' +
        _.get(data, 'referral_code')
    const timeout = parseDayjs(
        _.get(data, 'created')
    )
        .add(
            _.get(data, 'timeout'),
            'second'
        )
        .fromNow()
    return (
        <div className="flex flex-col p-3 pb-5 verticalList__large">
            <UpdateReferalCode referral={data}/>
            <div className="p-4 w-full flex items-center gap-3 rounded-lg border border-color-50 shadow-items">
                <Avatar
                    size={80}
                    className="flex flex-center background-100 text-color-400 rounded-lg"
                    icon={<AppLogoSvg/>}
                    src={organizationModel.getFullAvatarUrl(item)}
                />
                <div className="flex flex-col gap-3">
                    <Link
                        to={organizationModel.getLinkToDetail(item)}
                        className="font-bold text-lg text-color-000 no-underline">
                        {item.title}
                    </Link>
                    {renderIf(
                        item.premium,
                        <div className="mt-1">
                            <Tag color="gold">PREMIUM</Tag>
                        </div>
                    )}
                    <div className="flex items-center mr-3 rounded-full px-3 py-1 background-200">
                        <Badge
                            color="blue"
                            text={
                                <span className="text-sm text-color-300 italic">
                                  <span className="font-semibold text-color-000">
                                      {item.total_members}{' '}
                                  </span>
                                    {t('members')}
                              </span>
                            }
                        />
                    </div>
                </div>
            </div>
            {renderIf(
                item.description,
                <div className="text-xs">
                    {item.description}
                </div>
            )}
            <div className="pb-3">
                <div className="mb-2 font-medium text-color-300 italic">
                    {t('Send invitation to your friends, by sending a copy of the page link below')}
                </div>
                <div
                    onClick={() => {
                        copyToClipboard(inviteLink)
                        toggle(true)
                    }}>
                    <Input
                        className="rounded-lg"
                        value={inviteLink}
                        suffix={
                            <Button
                                className="font-medium text-xs button-rounded-md"
                                size="small"
                                type="primary">
                                {t(isToggle ? 'copied' : 'copy')}
                            </Button>
                        }
                    />
                </div>
                <div className="mb-2 text-xs text-color-300 italic">
                    {_.get(data, 'timeout', 0) ===
                    0 ||
                    _.get(
                        data,
                        'no_expired',
                        0
                    ) === 1
                        ? t('Permanent link')
                        : `${t(
                            'your invite link expires'
                        )} ${timeout}`}
                </div>
                <div className="mb-2 font-medium text-color-300 italic">
                    {t('Copy and share the page link below to your friends.')}
                    <div
                        onClick={() => {
                            copyToClipboard(
                                ROOT_URL +
                                organizationModel.getLinkToDetail(
                                    item
                                )
                            )
                            toggleCopy2(true)
                        }}>
                        <Input
                            className="rounded-lg"
                            value={
                                ROOT_URL +
                                organizationModel.getLinkToDetail(
                                    item
                                )
                            }
                            suffix={
                                <Button
                                    className="font-medium text-xs button-rounded-md"
                                    size="small"
                                    type="primary">
                                    {t(isToggleCopy2 ? 'copied' : 'copy')}
                                </Button>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Invite
